import { Extension } from '@tiptap/core';
import { NodeType, MarkType } from '../constants';

/**
 * we cannot use existing textAlign extension due to need to change textAlign global attribute renderHTML function
 * that not allowed by simple default extension configuration
 */
export const TextAlign = Extension.create({
    name: 'textAlign',
    addOptions() {
        return {
            types: [NodeType.HEADING, NodeType.PARAGRAPH, MarkType.LINK, NodeType.CODE_BLOCK, NodeType.BLOCKQUOTE],
            alignments: ['left', 'center', 'right', 'justify'],
            defaultAlignment: 'left',
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: element => {
                            return element.style.textAlign || this.options.defaultAlignment;
                        },
                        renderHTML: attributes => {
                            if (attributes.textAlign === this.options.defaultAlignment) {
                                return {};
                            }
                            /**
                             * because we gave users access to style attribute
                             * (and now editor doesn't reset it when renders HTML)
                             * we have to sanitize style attribute by ourselves to avoid duplication of textAlign written
                             * as independent attribute and part of style attribute string in the same time
                             */
                            if (/text-align/.test(attributes?.style)) {
                                attributes.style = attributes.style.replace(/text-align:\s?\w+;?\s?/, '');
                            }
                            return { style: `text-align: ${attributes.textAlign}` };
                        }
                    }
                }
            },
        ];
    },
    addCommands() {
        return {
            setTextAlign: (alignment) => ({ commands }) => {
                if (!this.options.alignments.includes(alignment)) {
                    return false;
                }
                return this.options.types
                    .map(type => commands.updateAttributes(type, { textAlign: alignment }))
                    .every(response => response);
            },
            unsetTextAlign: () => ({ commands }) => {
                return this.options.types
                    .map(type => commands.resetAttributes(type, 'textAlign'))
                    .every(response => response);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-l': () => this.editor.commands.setTextAlign('left'),
            'Mod-Shift-e': () => this.editor.commands.setTextAlign('center'),
            'Mod-Shift-r': () => this.editor.commands.setTextAlign('right'),
            'Mod-Shift-j': () => this.editor.commands.setTextAlign('justify'),
        };
    }
});
